import { useCallback, useMemo, useState } from "react";

import type { QuizBannerContent } from "../LoyaltyQuiz/types";

type UseQuizBannerParams = {
  articleType: "article" | "video" | "quiz";
  points: number | null;
  isCompleted: boolean | null;
  isLogged: boolean;
  isArticleAvailable: boolean;
  content?: QuizBannerContent;
};

export const useQuizBanner = ({
  articleType,
  points,
  isCompleted,
  isLogged,
  isArticleAvailable,
  content,
}: UseQuizBannerParams) => {
  const [isQuizModalOpen, setIsQuizModalOpen] = useState(false);
  const openQuiz = useCallback(() => setIsQuizModalOpen(true), []);
  const closeQuiz = useCallback(() => setIsQuizModalOpen(false), []);

  const isTypeOfQuiz = articleType === "quiz";

  const quizBannerTopProps = useMemo(() => {
    if (!isTypeOfQuiz || !isLogged || !isArticleAvailable || !content) {
      return null;
    }

    return { points, isCompleted, content, onStart: openQuiz };
  }, [isTypeOfQuiz, isLogged, isArticleAvailable, points, isCompleted, content, openQuiz]);

  const quizBannerBottomProps = useMemo(() => {
    if (!isTypeOfQuiz || !isLogged || !isArticleAvailable || !content) {
      return null;
    }

    return { points, isCompleted, content, onStart: openQuiz };
  }, [isTypeOfQuiz, isLogged, isArticleAvailable, points, isCompleted, content, openQuiz]);

  return {
    isTypeOfQuiz,
    isQuizModalOpen,
    openQuiz,
    closeQuiz,
    quizBannerTopProps,
    quizBannerBottomProps,
  };
};
